























import Vue, { PropType } from 'vue';
import { BButton } from 'bootstrap-vue';
import { upperCase } from 'lodash';
import { Control, ControlType } from '../types';

export default Vue.extend({
  name: 'Controls',
  components: {
    BButton,
  },
  props: {
    controls: {
      type: Array as PropType<Array<Control>>,
      default: () => [],
    },
  },
  methods: {
    controlClass(control: Control) {
      return { [control.type === ControlType.Function ? 'w-100' : 'w-50']: true };
    },
    controlValue(control: Control) {
      return control.type === ControlType.Function ? upperCase(control.value) + '()' : control.value;
    },
    controlClicked(control: Control) {
      this.$emit('click', control);
    },
  },
});
